import { styled } from '@mui/material/styles'
import { Theme } from '@mui/material/styles'

type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    mediumGrey?: { main: string }
    lightGrey?: { main: string }
  }
}

export const StyledLongText = styled('div')(({ theme }) => {
  const t = theme as MikeTheme
  return {
    maxWidth: '6vw',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'table-cell',
    paddingRight: theme.spacing(1)
  }
})

export const StyledBottomBorder = styled('div')(({ theme }) => {
  const t = theme as MikeTheme
  const grey = t.palette.mediumGrey?.main
  const lightgrey = t.palette.lightGrey?.main
  return {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    backgroundColor: lightgrey,
    borderBottom: '1px solid ' + grey
  }
})

export const StyledTooltipWrapper = styled('div')({
  maxHeight: '100%',
  height: '100%'
})
